import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2008"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5.345 4.508a.858.858 0 0 0 .859-.858c0-.474-.859-1.717-.859-1.717s-.858 1.242-.858 1.717c0 .474.383.858.858.858zm9.438 8.585c-.123-.07-3.046-1.697-7.381-.233-1.997.674-5.281.118-5.314.112a.7.7 0 0 0-.239 1.379c.09.016 1.416.241 2.967.241 1.009 0 2.113-.096 3.034-.406 3.709-1.25 6.141.067 6.239.122.334.19.763.075.956-.26a.702.702 0 0 0-.262-.955zm.348-5.8a.357.357 0 0 0 .33-.588l-3.474-3.918a1.01 1.01 0 0 0-1.224-.224L6.064 5.024a.357.357 0 0 0 .103.668l1.054.188-.836 4.549c-1.932.281-4.271-.113-4.298-.117a.7.7 0 1 0-.239 1.379c.09.016 1.414.24 2.964.24 1.01 0 2.115-.095 3.037-.406 3.709-1.249 6.14.067 6.239.122a.7.7 0 1 0 .694-1.215c-.045-.026-.472-.262-1.207-.478l.505-2.849 1.051.188zm-6.505 2.57.289-1.524a.496.496 0 0 1 .575-.405l1.757.314a.495.495 0 0 1 .401.573l-.138.787.01.002c-.835-.047-1.81.011-2.894.253zm-5.84-3.35c.474 0 .858-.384.858-.858s-.858-1.718-.858-1.718-.858 1.243-.858 1.717.384.859.858.859z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M4.062 9.646c.474 0 .858-.384.858-.858s-.858-1.717-.858-1.717-.859 1.242-.859 1.717.384.858.859.858z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }